import React from "react";
import Sorting from "../../../components/Sortcomponents/Sorting";
import styles from "./SortSection.module.scss";

const SortSection = ({ sortBy, setSortBy, sortOrder, setSortOrder }: { sortBy?: string, setSortBy?: (field: string) => void, sortOrder?: 'asc' | 'desc', setSortOrder?: (order: 'asc' | 'desc') => void }) => {
  return (
    <section className={styles.sortSection}>
      <Sorting sortBy={sortBy} setSortBy={setSortBy} sortOrder={sortOrder} setSortOrder={setSortOrder} />
    </section>
  );
};

export default SortSection;
